/**
 * Название Cookie, для получения аб фич
 */
export const PAGE_FEATURES_COOKIE_NAME = 'jl_features';
/**
 * Название свойства заголовков запроса, для получения полной ссылки текущей страницы
 */
export const HEADER_HREF_NAME = 'x-current-href';
